export const environment = {
  production: true,  
  apiUrl: 'https://rest.monex.com',
};
